import { request } from "utils/legacy_api";

export function create(attributes) {
  return request("/problem_reports", { method: "POST", body: attributes });
}
